import React from "react";

export default function Logo({ className = "", label = "Geolitio" }) {
  return (
    <span className={`geo-logo ${className}`} aria-label={label}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <linearGradient id="geoGrad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#0B2545" />
            <stop offset="1" stopColor="#0F4C81" />
          </linearGradient>
        </defs>
        <rect x="1" y="1" width="38" height="38" rx="9" fill="url(#geoGrad)" />
        <path
          d="M9 27 L15 19 L20 24 L26 14 L31 22"
          stroke="#E9C46A"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle cx="31" cy="22" r="2.4" fill="#C0562A" />
        <path d="M9 32 H31" stroke="rgba(255,255,255,0.35)" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
      <span className="geo-logo__wordmark">
        <span className="geo-logo__name">Geolitio</span>
        <span className="geo-logo__sub">.com</span>
      </span>
    </span>
  );
}
